<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="col-md-6" *ngIf="showMemberDropdown">
  <lib-members-selector [bindReviewer]="true" [visitKey]="visitMetaData.visitKey" [sessionId]="sessionId"
    (selectionChange)="memberChanged($event.value)"></lib-members-selector>
</div>

<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="distribute-tree mt-3">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle [class.active]="selectedNode?.id === node.id">
    <ng-container [ngTemplateOutlet]="treeNode"
      [ngTemplateOutletContext]="{ $implicit: node, class: 'px-3' }"></ng-container>
  </mat-tree-node>

  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <div class="mat-tree-node" [class.active]="selectedNode?.id === node.id">
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.criterionEnglishName">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <ng-container [ngTemplateOutlet]="treeNode"
        [ngTemplateOutletContext]="{ $implicit: node, class: '' }"></ng-container>
    </div>

    <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>

<ng-template #treeNode let-node let-class="class">
  <div (click)="rowClicked(node)" class="distribute-tree__node {{class}}" role="button">
    <span class="d-inline-block rounded-circle" [ngClass]="{'evaluated':node.evaluate,'pending':!node.evaluate}"></span>
    <span class="d-inline-block font-weight-bold mx-1 px-2 py-1 chip {{node.hasError ? 'error' : ''}}">{{node.criterionKey}}</span>
    {{
    node
    | propertyLocalized : ["criterionArabicName", "criterionEnglishName"]
    | async
    }}
  </div>
</ng-template>

<div class="row" *ngIf="selectedNode">
  <app-criterion-preview class="col-md-6"></app-criterion-preview>
  <app-criterion-decision class="col-md-6"></app-criterion-decision>
</div>

<app-executive-plan *ngIf="showExecutivePlan"></app-executive-plan>

<ng-container *ngIf="executeVisitType != 'SessionDetails'">
  <app-decision-summary *ngFor="let item of summaries" [title]="item.label" [type]="item.type"
    [filter]="item.filter"></app-decision-summary>
</ng-container>
